/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['svg-icon{display:inline-block;width:24px;height:24px;vertical-align:inherit}svg-icon>svg{display:block;fill:currentColor;width:inherit;height:inherit}svg-icon.size-18{width:18px;height:18px}svg-icon.size-20{width:20px;height:20px}svg-icon.size-22{width:22px;height:22px}svg-icon.align-middle{vertical-align:middle}svg-icon.block{display:block}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvc2hhcmVkL3N2Zy1pY29uL3N2Zy1pY29uLmNvbXBvbmVudC5zY3NzLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9tbnQvZS9hcHBzL2hlbHBkZXNrL2NsaWVudC9zcmMvYXBwL3NoYXJlZC9zdmctaWNvbi9zdmctaWNvbi5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/$$_gendir/app/shared/svg-icon/svg-icon.component.scss.ngstyle.ts